import React from 'react';

export interface OcConnectWidgetProps {
  slotId: string;
}

// Typing for the `<oc-connect-widget>` custom element used in JSX.
interface OcConnectWidgetAttributes {
  'slot-id': string;
}

declare global {
  namespace React.JSX {
    interface IntrinsicElements {
      'oc-connect-widget': OcConnectWidgetAttributes;
    }
  }
}

/**
 * Single source of truth for the page-template OC_CONNECT_WIDGET component, shared by RR7 atlas and
 * atlas-astro. Renders the `<oc-connect-widget>` custom element that is upgraded on the client by the
 * external OddsChecker Connect widget script. No interactivity beyond the custom element itself — the
 * shared component is purely static markup; each app's glue handles script injection.
 */
export const OcConnectWidget = ({ slotId }: OcConnectWidgetProps) => (
  <div data-testid="oc-connect-widget-div">
    <oc-connect-widget slot-id={slotId}></oc-connect-widget>
  </div>
);
